import Main from "@user/views/common/main";
import Dashboard from "@user/views/common/dashboard";
import PopupSearchPn from "@user/views/popup/popup_search_pn";
import PopupRegistPn from "@user/views/popup/popup_regist_pn";
import PopupSkuInfo from "@user/views/popup/popup_sku_info";
import PopupPrintTrtag from "@user/views/popup/popup_print_trtag";
import InoutWork from "@user/views/inoutbound/inout_work";
import PopupTrSnChange from "@user/views/inoutbound/popup_tr_sn_change";
import PopupStockInfo from "@user/views/inoutbound/popup_stock_info";
import PopupSkuReq from "@user/views/inoutbound/popup_sku_req";
import WorkstationManage from "@user/views/inoutbound/workstation_manage";
import PopupLoadcapaRate from "@user/views/inoutbound/popup_loadcapa_rate";
import PopupInboundInfo from "@user/views/inoutbound/popup_inbound_info";
import PopupSkuRelease from "@user/views/inoutbound/popup_sku_release";
import PopupSkuCell from "@user/views/inoutbound/popup_sku_cell";
import PopupSkuAdd from "@user/views/inoutbound/popup_sku_add";
import BackupWork from "@user/views/inoutbound/backup_work";
import PopupBackupwork from "@user/views/inoutbound/popup_backupwork";
import PopupTempwork from "@user/views/inoutbound/popup_tempwork";
import PopupBackupStockInfo from "@user/views/inoutbound/popup_backup_stock_info";
import UnusedReturn from "@user/views/inoutbound/unused_return";
import PopupUnusedReturn from "@user/views/inoutbound/popup_unused_return";
import ForceCompleteList from "@user/views/inoutbound/force_complete_list";
import TempWorkList from "@user/views/inoutbound/temp_work_list";
import PopupTempWork from "@user/views/inoutbound/popup_temp_work";
import WorkHoldList from "@user/views/inoutbound/work_hold_list";
import WorkStatus from "@user/views/work/work_status";
import RackReorder from "@user/views/work/rack_reorder";
import StockStatus from "@user/views/stock/stock_status";
import PopupSearchInput from "@user/views/stock/popup_search_input";
import PopupStockHistory from "@user/views/stock/popup_stock_history";
import PopupStockAdd from "@user/views/stock/popup_stock_add";
import CellMonitoring from "@user/views/stock/cell_monitoring";
import CellInfo from "@user/views/stock/cell_info";
import PopupCellInfo from "@user/views/stock/popup_cell_info";
import ZoneInfo from "@user/views/stock/zone_info";
import InventoryAuditManageList from "@user/views/stock/inventory_audit_manage_list";
import InventoryAuditManageDetail from "@user/views/stock/inventory_audit_manage_detail";
import InventoryAuditList from "@user/views/stock/inventory_audit_list";
import InventoryAuditRegist from "@user/views/stock/inventory_audit_regist";
import InventoryAuditDetail from "@user/views/stock/inventory_audit_detail";
import AuditManageList from "@user/views/stock/audit_manage_list";
import AuditManageDetail from "@user/views/stock/audit_manage_detail";
import PopupAuditManage from "@user/views/stock/popup_audit_manage";
import AgingInventory from "@user/views/stock/aging_inventory";
import InventoryCompare from "@user/views/stock/inventory_compare";
import InoutHistory from "@user/views/report/inout_history";
import LocationStatus from "@user/views/report/location_status";
import HourlyInoutStatus from "@user/views/report/hourly_inout_status";
import MonthlyInoutStatus from "@user/views/report/monthly_inout_status";
import DailyInoutStatus from "@user/views/report/daily_inout_status";
import InoutFrequencyStatus from "@user/views/report/inout_frequency_status";
import InventoryAuditStatus from "@user/views/report/inventory_audit_status";
import SntrDiscrepancyStatus from "@user/views/report/sntr_discrepancy_status";
import ExpirationStatus from "@user/views/report/expiration_status";
import ResultSummary from "@user/views/report/result_summary";
import EquipmentErrorLog from "@user/views/log/equipment_error_log";
import WmsErrorLog from "@user/views/log/wms_error_log";
import PopupLogDetail from "@user/views/log/popup_log_detail";
import ErpIfLogList from "@user/views/log/erp_if_log_list";
import ErpIfLogDetail from "@user/views/log/erp_if_log_detail";
import SkuPickingLog from "@user/views/log/sku_picking_log";
import ReInboundLog from "@user/views/log/reInbound_log";
import SystemUsageLog from "@user/views/log/system_usage_log";
import MfcIfLog from "@user/views/log/mfc_if_log";
import PnManageList from "@user/views/master/pn_manage_list";
import PnManageDetail from "@user/views/master/pn_manage_detail";
import PrintBarcode from "@user/views/master/print_barcode";
import AuthManage from "@user/views/system/auth_manage";
import CodeList from "@user/views/system/code_list";
import CodeDetail from "@user/views/system/code_detail";
import PopupInoutWork from "@user/views/sample/popup_inout_work";

export interface Route {
  id?: string;
  label?: string;
  path: string;
  component: any;
  children?: Route[];
};

const _routes: Route[] = [
  { label: "메인", path: "/", component: Main },
  { label: "대시보드", path: "/common/dashboard", component: Dashboard },
  { path: "/popup/popup_search_pn", component: PopupSearchPn },
  { path: "/popup/popup_regist_pn", component: PopupRegistPn },
  { path: "/popup/popup_sku_info", component: PopupSkuInfo },
  { label: "TR Tag 출력 팝업", path: "/popup/popup_print_trtag", component: PopupPrintTrtag },
  { label: "입출고작업", path: "/inoutbound/inout_work", component: InoutWork },
  { path: "/inoutbound/popup_tr_sn_change", component: PopupTrSnChange },
  { path: "/inoutbound/popup_stock_info", component: PopupStockInfo },
  { path: "/inoutbound/popup_sku_req", component: PopupSkuReq },
  { label: "작업대", path: "/inoutbound/workstation_manage", component: WorkstationManage },
  { path: "/inoutbound/popup_loadcapa_rate", component: PopupLoadcapaRate },
  { path: "/inoutbound/popup_inbound_info", component: PopupInboundInfo },
  { path: "/inoutbound/popup_sku_release", component: PopupSkuRelease },
  { path: "/inoutbound/popup_sku_cell", component: PopupSkuCell },
  { path: "/inoutbound/popup_sku_add", component: PopupSkuAdd },
  { label: "Backup작업", path: "/inoutbound/backup_work", component: BackupWork },
  { path: "/inoutbound/popup_backupwork", component: PopupBackupwork },
  { path: "/inoutbound/popup_tempwork", component: PopupTempwork },
  { path: "/inoutbound/popup_backup_stock_info", component: PopupBackupStockInfo },
  { label: "미사용반납관리", path: "/inoutbound/unused_return", component: UnusedReturn },
  { path: "/inoutbound/popup_unused_return", component: PopupUnusedReturn },
  { label: "강제완료정보관리", path: "/inoutbound/force_complete_list", component: ForceCompleteList },
  { label: "임시작업관리", path: "/inoutbound/temp_work_list", component: TempWorkList, },
  { path: "/inoutbound/popup_temp_work", component: PopupTempWork },
  { label: "작업보류목록", path: "/inoutbound/work_hold_list", component: WorkHoldList },
  { label: "작업상태", path: "/work/work_status", component: WorkStatus },
  { label: "자동창고 RACK 정리", path: "/work/rack_reorder", component: RackReorder },
  { label: "재고현황", path: "/stock/stock_status", component: StockStatus },
  { path: "/stock/popup_search_input", component: PopupSearchInput },
  { path: "/stock/popup_stock_history", component: PopupStockHistory },
  { path: "/stock/popup_stock_add", component: PopupStockAdd },
  { label: "CELL 모니터링", path: "/stock/cell_monitoring", component: CellMonitoring },
  { label: "CELL 정보", path: "/stock/cell_info", component: CellInfo },
  { path: "/stock/popup_cell_info", component: PopupCellInfo },
  { label: "상세 구획 정보", path: "/stock/zone_info", component: ZoneInfo },
  { label: "재고실사 관리", path: "/stock/inventory_audit_manage_list", component: InventoryAuditManageList,
    children: [
      { path: "/stock/inventory_audit_manage_detail", component: InventoryAuditManageDetail },
    ],
  },
  { label: "재고실사", path: "/stock/inventory_audit_list", component: InventoryAuditList,
    children: [
      { path: "/stock/inventory_audit_regist", component: InventoryAuditRegist },
      { path: "/stock/inventory_audit_detail", component: InventoryAuditDetail },
    ],
  },
  { label: "재고실사 조치", path: "/stock/audit_manage_list", component: AuditManageList,
    children: [
      { path: "/stock/audit_manage_detail", component: AuditManageDetail },
    ],
  },
  { path: "/stock/popup_audit_manage", component: PopupAuditManage },
  { label: "장기 미출고", path: "/stock/aging_inventory", component: AgingInventory },
  { label: "ERP 재고 비교", path: "/stock/inventory_compare", component: InventoryCompare },
  { label: "입출고 실적", path: "/report/inout_history", component: InoutHistory },
  { label: "로케이션 현황", path: "/report/location_status", component: LocationStatus },
  { label: "시간별 입출고 현황", path: "/report/hourly_inout_status", component: HourlyInoutStatus },
  { label: "월별 입출고 현황", path: "/report/monthly_inout_status", component: MonthlyInoutStatus },
  { label: "일별 입출고 현황", path: "/report/daily_inout_status", component: DailyInoutStatus },
  { label: "수불 빈도 현황", path: "/report/inout_frequency_status", component: InoutFrequencyStatus },
  { label: "재고실사 현황", path: "/report/inventory_audit_status", component: InventoryAuditStatus },
  { label: "SN/TR 불일치 현황", path: "/report/sntr_discrepancy_status", component: SntrDiscrepancyStatus },
  { label: "시효 만료 현황", path: "/report/expiration_status", component: ExpirationStatus },
  { label: "종합실적", path: "/report/result_summary", component: ResultSummary },
  { label: "설비 오류 로그", path: "/log/equipment_error_log", component: EquipmentErrorLog },
  { label: "시스템 오류 로그", path: "/log/wms_error_log", component: WmsErrorLog },
  { path: "/log/popup_log_detail", component: PopupLogDetail },
  { label: "MFC I/F 로그", path: "/log/mfc_if_log", component: MfcIfLog },
  { label: "ERP I/F 로그", path: "/log/erp_if_log_list", component: ErpIfLogList,
    children: [
      { path: "/log/erp_if_log_detail", component: ErpIfLogDetail },
    ],
  },
  { label: "SKU 피킹 로그", path: "/log/sku_picking_log", component: SkuPickingLog },
  { label: "미작업 재입고 로그", path: "/log/reInbound_log", component: ReInboundLog },
  { label: "시스템 사용 로그", path: "/log/system_usage_log", component: SystemUsageLog },
  { label: "PN관리", path: "/master/pn_manage_list", component: PnManageList,
    children: [
      { path: "/master/pn_manage_detail", component: PnManageDetail },
    ],
  },
  { label: "바코드출력", path: "/master/print_barcode", component: PrintBarcode },
  { label: "권한관리", path: "/system/auth_manage", component: AuthManage },
  { label: "공통코드", path: "/system/code_list", component: CodeList,
    children: [
      { path: "/system/code_detail", component: CodeDetail },
    ],
  },
  { path: "/sample/popup_inout_work", component: PopupInoutWork },
];

const routes: Route[] = [];
_routes.forEach(route => {
  route.id = route.path;
  routes.push(route);
  route.children?.forEach((child: Route) => {
    child.id = route.path;
    if (!child.label) {
      child.label = route.label;
    }
    routes.push(child);
  });
});

export function resolveRoute(path: string): Route {
  return routes.find(route => route.path == path)!;
}
